import React from 'react';
import { Link } from 'react-router-dom';
import { Grid } from '@material-ui/core';

import CommentCard from './CommentCard';

export default function GroupCommentsByProposal({ sortedComments, classes }) {
  return sortedComments.map(({ proposalId, number, name, comments }, index) => {
    return (
      <div key={`${number}-${index}`} className={classes.wrapper}>
        <Link className="normal-text" to={`/proposal/${proposalId}`}>
          <h2
            className={`${classes.groupTitle} ${classes.groupTitleOnHover}`}
          >{`${number} - ${name}`}</h2>
        </Link>
        <Grid container spacing={3}>
          {comments.map((comment, index) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              key={index}
              style={{ boxSizing: 'border-box', marginBottom: '40px' }}
            >
              <CommentCard comment={comment} />
            </Grid>
          ))}
        </Grid>
      </div>
    );
  });
}
